(() => {
  'use strict';

  const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');
  const CHAT_HOST_SELECTOR = 'shopify-chat';
  const NATIVE_ACTIVATOR_SELECTOR = '.activator';
  const PROXY_SELECTOR = '[data-bc-mobile-chat-launcher]';
  const HIDE_STYLE_ID = 'bc-hide-native-shopify-chat-activator';
  const MAX_SHADOW_RETRIES = 20;
  let updateTimer = null;
  let shadowRetryTimer = null;
  let shadowRetryCount = 0;

  function findNativeChatHost() {
    const directHost = document.querySelector(CHAT_HOST_SELECTOR);

    if (directHost?.shadowRoot) {
      return directHost;
    }

    for (const element of document.querySelectorAll('*')) {
      if (
        element.shadowRoot?.querySelector(NATIVE_ACTIVATOR_SELECTOR) ||
        element.shadowRoot?.querySelector('button[aria-label*="chat" i]')
      ) {
        return element;
      }
    }

    return directHost;
  }

  function findNativeChatActivator() {
    const host = findNativeChatHost();

    if (!host?.shadowRoot) return null;

    return (
      host.shadowRoot.querySelector(NATIVE_ACTIVATOR_SELECTOR) ||
      host.shadowRoot.querySelector('button[aria-label*="chat" i], button')
    );
  }

  function getHideStyle(host) {
    return host?.shadowRoot?.getElementById(HIDE_STYLE_ID) || null;
  }

  function hideNativeMobileActivator(host) {
    if (!host?.shadowRoot) return false;

    let style = getHideStyle(host);

    if (!style) {
      style = document.createElement('style');
      style.id = HIDE_STYLE_ID;
      host.shadowRoot.appendChild(style);
    }

    style.textContent = `
      @media screen and (max-width: 749px) {
        .activator-nudge,
        ${NATIVE_ACTIVATOR_SELECTOR} {
          position: fixed !important;
          top: 0 !important;
          left: -10000px !important;
          right: auto !important;
          bottom: auto !important;
          width: 1px !important;
          height: 1px !important;
          min-width: 1px !important;
          min-height: 1px !important;
          max-width: 1px !important;
          max-height: 1px !important;
          margin: 0 !important;
          padding: 0 !important;
          border: 0 !important;
          opacity: 0 !important;
          pointer-events: none !important;
          overflow: hidden !important;
          transform: none !important;
        }
      }
    `;

    return Boolean(findNativeChatActivator());
  }

  function restoreNativeDesktopActivator() {
    const host = findNativeChatHost();
    getHideStyle(host)?.remove();
  }

  function createProxyButton() {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'bc-mobile-chat-launcher';
    button.setAttribute('aria-label', 'Open chat');
    button.setAttribute('data-bc-mobile-chat-launcher', '');
    button.innerHTML = `
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        focusable="false"
      >
        <path
          d="M5 4.75h14A2.25 2.25 0 0 1 21.25 7v8A2.25 2.25 0 0 1 19 17.25h-7.1l-4.65 3.2v-3.2H5A2.25 2.25 0 0 1 2.75 15V7A2.25 2.25 0 0 1 5 4.75Z"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linejoin="round"
        />
      </svg>
    `;

    button.addEventListener('click', () => {
      const activator = findNativeChatActivator();

      if (!activator) {
        console.warn(
          '[Billiard City Chat] Native Shopify Chat activator not found.'
        );
        return;
      }

      activator.click();
    });

    return button;
  }

  function ensureSingleProxy() {
    const proxies = [...document.querySelectorAll(PROXY_SELECTOR)];
    const proxy = proxies.shift() || createProxyButton();

    proxies.forEach((duplicate) => duplicate.remove());

    if (!proxy.isConnected) {
      document.body.appendChild(proxy);
    }

    return proxy;
  }

  function clearShadowRetry() {
    if (shadowRetryTimer) {
      window.clearTimeout(shadowRetryTimer);
      shadowRetryTimer = null;
    }
  }

  function retryShadowSetup() {
    clearShadowRetry();

    if (
      !MOBILE_QUERY.matches ||
      shadowRetryCount >= MAX_SHADOW_RETRIES
    ) {
      return;
    }

    shadowRetryCount += 1;
    shadowRetryTimer = window.setTimeout(updateMobileChat, 250);
  }

  function updateMobileChat() {
    updateTimer = null;

    if (!MOBILE_QUERY.matches) {
      document.querySelectorAll(PROXY_SELECTOR).forEach((proxy) => {
        proxy.remove();
      });
      restoreNativeDesktopActivator();
      clearShadowRetry();
      shadowRetryCount = 0;
      return;
    }

    ensureSingleProxy();

    const host = findNativeChatHost();
    const isReady = hideNativeMobileActivator(host);

    if (isReady) {
      clearShadowRetry();
      shadowRetryCount = 0;
    } else {
      retryShadowSetup();
    }
  }

  function scheduleUpdate() {
    if (updateTimer) return;

    updateTimer = window.setTimeout(updateMobileChat, 50);
  }

  const observer = new MutationObserver(scheduleUpdate);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  if (MOBILE_QUERY.addEventListener) {
    MOBILE_QUERY.addEventListener('change', scheduleUpdate);
  } else {
    MOBILE_QUERY.addListener(scheduleUpdate);
  }

  updateMobileChat();
})();
